import { FishBehaviorType, SpawnFrequency } from "./enums";

export interface FishData {
    fishName: string;
    textureKey: string;
    pointValue: number;
    swimSpeed: number;
    behaviorType: FishBehaviorType;
    spawnFrequency: SpawnFrequency;
}

export const fishData: FishData[] = [
    {
        fishName: "Bluegill",
        textureKey: "bluegill",
        pointValue: 10,
        swimSpeed: 80,
        behaviorType: FishBehaviorType.Drift,
        spawnFrequency: SpawnFrequency.VeryCommon,
    },
    {
        fishName: "Crappie",
        textureKey: "crappie",
        pointValue: 10,
        swimSpeed: 80,
        behaviorType: FishBehaviorType.Drift,
        spawnFrequency: SpawnFrequency.VeryCommon,
    },
    {
        fishName: "Perch",
        textureKey: "perch",
        pointValue: 10,
        swimSpeed: 85,
        behaviorType: FishBehaviorType.Drift,
        spawnFrequency: SpawnFrequency.Common,
    },
    {
        fishName: "Largemouth Bass",
        textureKey: "largemouth-bass",
        pointValue: 20,
        swimSpeed: 100,
        behaviorType: FishBehaviorType.Patrol,
        spawnFrequency: SpawnFrequency.Common,
    },
    {
        fishName: "Smallmouth Bass",
        textureKey: "smallmouth-bass",
        pointValue: 20,
        swimSpeed: 105,
        behaviorType: FishBehaviorType.Patrol,
        spawnFrequency: SpawnFrequency.Common,
    },
    {
        fishName: "Walleye",
        textureKey: "walleye",
        pointValue: 25,
        swimSpeed: 115,
        behaviorType: FishBehaviorType.Cruise,
        spawnFrequency: SpawnFrequency.Uncommon,
    },
    {
        fishName: "Trout",
        textureKey: "trout",
        pointValue: 25,
        swimSpeed: 110,
        behaviorType: FishBehaviorType.FigureEight,
        spawnFrequency: SpawnFrequency.Uncommon,
    },
    {
        fishName: "Northern Pike",
        textureKey: "northern-pike",
        pointValue: 30,
        swimSpeed: 170,
        behaviorType: FishBehaviorType.DartPause,
        spawnFrequency: SpawnFrequency.Uncommon,
    },
    {
        fishName: "Musky",
        textureKey: "musky",
        pointValue: 50,
        swimSpeed: 130,
        behaviorType: FishBehaviorType.Flee,
        spawnFrequency: SpawnFrequency.Rare,
    },
];

export const spawnFrequencyWeights: Record<SpawnFrequency, number> = {
    [SpawnFrequency.VeryCommon]: 36,
    [SpawnFrequency.Common]: 24,
    [SpawnFrequency.Uncommon]: 12,
    [SpawnFrequency.Rare]: 4,
};
